/** Player MQ events → CSL feature events. */

import type { TPlayer } from '@setplex/pureya'

import { Events } from '@setplex/pureya'
import { createEffect, sample, scopeBind } from 'effector'
import { mq, PLAYER } from '~/shared/mq'
import {
  cslErrorDetected,
  contentChanged,
  init,
  playbackStarted,
  retryAttempted,
} from './model'

type MqVjsEvent = { player: TPlayer }

const attachListenersFx = createEffect(() => {
  const _cslErrorDetected = scopeBind(cslErrorDetected, { safe: true })
  const _playbackStarted = scopeBind(playbackStarted, { safe: true })
  const _retryAttempted = scopeBind(retryAttempted, { safe: true })
  const _contentChanged = scopeBind(contentChanged, { safe: true })

  /** Player event 433 CSL error → cslErrorDetected. */
  mq.on<MqVjsEvent>(`${PLAYER}/error`, (msg) => {
    const error = msg?.player?.error() as
      | (ReturnType<TPlayer['error']> & {
          originalCode?: number
          metadata?: {
            csl?: number | null
          }
        })
      | null
    if (!error) return
    if (error.originalCode !== 433) return

    const csl = error.metadata?.csl ?? null
    _cslErrorDetected({ csl })
  })

  /** Playback started — reset CSL state. */
  mq.on(`${PLAYER}/playing`, () => {
    _playbackStarted()
  })

  /** CSL Try Again → retryAttempted. */
  mq.on(`${PLAYER}/${Events.Player.ConcurrentStreamRetry}`, () => {
    _retryAttempted()
  })

  /** Content changed — reset state. */
  mq.on(`${PLAYER}/${Events.Media.ContentChanged}`, () => {
    _contentChanged()
  })
})

sample({ clock: init, target: attachListenersFx })
